module.exports = __webpack_public_path__ + "img/test_l.34ea4a82.png";